import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { v4 as uuidv4 } from 'uuid';
export var GuidHelper =
/*#__PURE__*/
function () {
  function GuidHelper() {
    _classCallCheck(this, GuidHelper);
  }

  _createClass(GuidHelper, [{
    key: "genereateGuid",
    value: function genereateGuid() {
      return uuidv4();
    }
  }]);

  return GuidHelper;
}();
export var guidHelper = new GuidHelper();